export default __webpack_public_path__ + "static/1163-9f9568970f83d23a918bb24c76f0c219.gif";